import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';
import experimentsFlagsHelperSSR from '@zola-helpers/server/dist/es/experiments';

// Experiment Keys
// export const EXAMPLE_FLAG = 'example-flag'; // https://newamsterdamlabs.atlassian.net/browse/CE-1147
export const PAPER_ADD_ONS = 'paper-add-ons';
export const CORE_CONTACT_COLLECTOR_REDESIGN = 'core-contact-collector-redesign';
export const HOMEPAGE_HERO_COPY = 'homepage-hero-copy';

/**
 * Experiment flag for PE-19: try a different hero image on the paper LP
 *
 * @see https://newamsterdamlabs.atlassian.net/browse/PE-19
 */
export const PAPER_LP_HERO_IMAGE = 'paper-lp-hero-image';

/**
 * Experiment flag for PE-18: try a different hero image on the registry LP
 *
 * @see https://newamsterdamlabs.atlassian.net/browse/PE-18
 */
export const REGISTRY_LP_HERO_IMAGE = 'registry-lp-hero-image';

// Seasonal flags
export const HOLIDAY_CARDS = 'holiday-cards';
export const HOLIDAY_SHOPS = 'holiday-shops';

const FALLBACK_VARIATIONS = {
  // [EXAMPLE_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_ADD_ONS]: experimentFlagsHelper.createExperimentFlags(),
  [CORE_CONTACT_COLLECTOR_REDESIGN]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAY_CARDS]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAY_SHOPS]: experimentFlagsHelper.createExperimentFlags(),
  [HOMEPAGE_HERO_COPY]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);

const FALLBACK_VARIATIONS_SSR = {
  // [EXAMPLE_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [CORE_CONTACT_COLLECTOR_REDESIGN]: experimentFlagsHelper.createExperimentFlags(),
  [HOMEPAGE_HERO_COPY]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_LP_HERO_IMAGE]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_LP_HERO_IMAGE]: experimentFlagsHelper.createExperimentFlags(),
};

export const experimentFlagsSSR =
  experimentsFlagsHelperSSR.makeExperimentFlags(FALLBACK_VARIATIONS_SSR);
